<template>
    <div class="serial-date">
        {{redeemDate}}
    </div>
</template>
<script>
//plugin
import Moment from 'moment';
//helper
import Locale from '@/helper/locale/locale.js';
import Util from '@/helper/Utility.js';
export default {
    name: 'SerialRedeemDate',
    props: {
        delimiter: String,
        lbl: String,
        isUtc: Boolean,
        isShowTime: Boolean,

        campaign: Object
    },
    data: function () {
        return {
            redeemDate: ''
        }
    },
    created: function () {
        if (!this.campaign.redeemDate) return;

        console.log('this.campaign.redeemDate', this.campaign.redeemDate);

        var delimiter = !this.delimiter ? '/' : this.delimiter;

        var result = Moment.unix(this.campaign.redeemDate);
        if (this.isUtc) result.utc();

        var year = result.format('YYYY');
        if (Locale.getLocaleCode() === 1054) year = result.get('year') + 543;

        var month = result.format('MM');
        var day = result.format('DD');
        var date = `${day}${delimiter}${month}${delimiter}${year}`;
        if (this.isShowTime) date = `${date} - ${result.format('HH:mm')}`;

        this.redeemDate = Util.stringFormat(this.lbl, date);
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.serial-date {
    font-size: 16px;
    font-weight: 400;
    color: $color-gray;
    text-align: center;
    margin-bottom: 8px;
}
</style>
